<div class="event-container" [ngClass]="{'selected': selected}">
  <div class="device-table-container">
    <table #deviceEventTable="matSort" mat-table [dataSource]="deviceEvents" matSort>
      <ng-container matColumnDef="eventText">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'devices.detail.events.header.event-text' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.eventText }}
        </td>
      </ng-container>
      <ng-container matColumnDef="counter">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'devices.detail.events.header.counter' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.counter }}
        </td>
      </ng-container>
      <ng-container matColumnDef="recordStatus">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'devices.detail.events.header.record-status' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.recordStatus }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedTimestamp">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'devices.detail.events.header.last-updated' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastUpdatedTimestamp }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="filteredDeviceEventColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: filteredDeviceEventColumns;" class="element-row"
          (click)="selectEventItem(element)">
    </table>
  </div>

  <mat-paginator #deviceEventItemPaginator [pageSizeOptions]="[10, 25, 50]" [showFirstLastButtons]="!mobile"
                 [hidePageSize]="mobile">
  </mat-paginator>
  <mat-button-toggle-group [multiple]="true" #deviceEventItemsDetailGroup="matButtonToggleGroup"
                           [(ngModel)]="deviceEventColumnsToggle" class="events-toggle">
    <mat-button-toggle value="eventText" class="event-toggle-item">
      <span>{{ 'devices.detail.events.header.event-text' | translate }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="counter" class="event-toggle-item">
      <span>{{ 'devices.detail.events.header.counter' | translate }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="recordStatus" class="event-toggle-item">
      <span>{{ 'devices.detail.events.header.record-status' | translate }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastUpdatedTimestamp" class="event-toggle-item">
      <span>{{ 'devices.detail.events.header.last-updated' | translate }}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>

<div class="event-container event-detail" [ngClass]="{'selected': selected}">
  <div class="header-container">
    <button class="event-back-button" mat-flat-button color="primary" (click)="selected = undefined; " matRipple
            [ngClass]="{ show: selected }">
      <mat-icon class="event-back-icon">arrow_back</mat-icon>
    </button>
  </div>
  <div #eventsAttrTable class="event-attr-table-container">
    <table #deviceEventItemsDetailTable="matSort" mat-table [dataSource]="deviceEventItemAttributes"
           matSort aria-label="element-detail">
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'devices.detail.events.header.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="value">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'devices.detail.events.header.value' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.value }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="deviceEventAttrColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: deviceEventAttrColumns;"></tr>
    </table>
  </div>
  <mat-paginator #deviceEventsDetailPaginator [pageSizeOptions]="[10, 25, 50]"
                 [showFirstLastButtons]="!mobile" [hidePageSize]="mobile">
  </mat-paginator>
</div>
